import { MessageBox, Notification } from 'element-ui'

export function notifySuccess(message) {
  Notification({
    title: "成功",
    message: message,
    type: "success",
  });
}
export function notifyFail(message) {
  Notification({
    title: "失败",
    message: message,
    type: "error",
  });
}

export function messageConfirm(content) {
  return MessageBox.confirm(content, "系统提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    center: true,
    type: "warning",
  });
}